"use client";

import { useEffect } from "react";
import { MoveLeft, RefreshCcw } from "lucide-react";
import Link from "next/link";
import { SEO_CONFIG } from "@/lib/seo-config";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error("Blog Post Error:", error);
  }, [error]);

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-background text-foreground p-6">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="space-y-2">
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-red-500">
            Something went wrong!
          </h2>
          <p className="text-muted-foreground text-sm">
            We couldn't load this blog post. Please try again.
          </p>
          <p className="text-xs font-mono bg-muted/50 p-2 rounded text-left overflow-auto max-h-32 opacity-70">
            {error.message || "Unknown error occurred"}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => reset()}
            className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full sm:w-auto gap-2"
          >
            <RefreshCcw className="w-4 h-4" />
            Try Again
          </button>

          <Link href={SEO_CONFIG.blogDomain} className="w-full sm:w-auto">
            <button className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full gap-2">
              <MoveLeft className="w-4 h-4" />
              Back to Blogs
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
